import simbApi from ".";
import { RECORD_CONSENT, GET_CONSENT_STATUS } from "../../data/constants/endpoints";
import type {
  ConsentStatusItem,
  RecordConsentBody,
  RecordConsentResult,
} from "../consentTypes";

export const getConsentStatus = async (): Promise<ConsentStatusItem[]> => {
  const response = await simbApi.get(GET_CONSENT_STATUS);
  return response.data?.data?.consents ?? [];
};

export const recordConsent = async (
  body: RecordConsentBody,
): Promise<RecordConsentResult> => {
  const response = await simbApi.post(RECORD_CONSENT, body);
  return response.data?.data ?? { recorded: [], skipped: [] };
};
